// const mapMemberReport = (datas) => {
//   return !datas
//     ? []
//     : datas.map((t) => {
//         return {
//           Name: `${t.firstname} ${t.lastname}`,

import { converttoPhoneFormat } from "../../../../../../utils";

//           "Current Tier": t.tier,
//           "LTV(THB)": t.ltv ?? 0,
//           "Total Transactions": t.payment?.total_transaction ?? 0,
//           "Total Earn":
//             (t.payment?.total_earn?.reward ?? 0) +
//             (t.earn?.reward?.total_amount ?? 0),
//         };
//       });
// };

// const makeMemberSummary = (datas) => {
//   return datas.reduce(
//     (total, row) => {
//       return {
//         Name: "Total",

//         Tier: "",
//         "LTV(THB)": row["LTV(THB)"] + total["LTV(THB)"],
//         "Total Transactions":
//           row["Total Transactions"] + total["Total Transactions"],
//         "Total Earn": row["Total Earn"] + total["Total Earn"],
//       };
//     },
//     {
//       Name: "Total",
//       ID: "",
//       Tier: "",
//       "LTV(THB)": 0,
//       "Total Transactions": 0,
//       "Total Earn": 0,
//       "Remaining Points": 0,
//     }
//   );
// };

const mapMemberReport = (datas) => {
  return !datas
    ? []
    : datas.map((t) => {
        return {
          Name: `${t.firstname} ${t.lastname}`,
          Phone: t.phone ? converttoPhoneFormat(t.phone, true) : "-",
          "Current Tier": t.tier,
          "LTV(THB)": t.ltv ?? 0,
          "Total Transactions": t.payment?.total_transaction ?? 0,
          "Total Earn":
            (t.payment?.total_earn?.reward ?? 0) +
            (t.earn?.reward?.total_amount ?? 0),
        };
      });
};

const makeMemberSummary = (datas) => {
  return datas.reduce(
    (total, row) => {
      return {
        Name: "Total",
        Phone: "",
        Tier: "",
        "LTV(THB)": row["LTV(THB)"] + total["LTV(THB)"],
        "Total Transactions":
          row["Total Transactions"] + total["Total Transactions"],
        "Total Earn": row["Total Earn"] + total["Total Earn"],
      };
    },
    {
      Name: "Total",
      Phone: "",
      Tier: "",
      "LTV(THB)": 0,
      "Total Transactions": 0,
      "Total Earn": 0,
      "Remaining Points": 0,
    }
  );
};

const mapMemberBigSpender = (datas) => {
  return !datas
    ? []
    : datas.map((t) => ({
        Name: t.firstname ? `${t.firstname} ${t.lastname}` : "",
        "Tier.": t.tier,
        "LTV(THB)": t.ltv,
        "Total Revenue (THB)": t.payment?.total_revenue,
        Transactions: t.payment.total_transaction,
        "Frequent Category": t.life_time.top_frequent_category?.name,
        "Expensive Category": t.life_time.top_expense_category?.name,
        "Frequent Product": t.life_time.top_frequent_product?.name,
        "Expensive Product": t.life_time.top_expense_product?.name,
      }));
};

const makeMemberBigSpenderSummary = (datas) => {
  return datas.reduce(
    (total, row) => ({
      Name: "Total",
      "Tier.": "",
      "LTV(THB)": row["LTV(THB)"] + total["LTV(THB)"],
      "Total Revenue (THB)":
        row["Total Revenue (THB)"] + total["Total Revenue (THB)"],
      Transactions: row["Transactions"] + total["Transactions"],
      "Frequent Category": "",
      "Expensive Category": "",
      "Frequent Product": "",
      "Expensive Product": "",
    }),
    {
      Name: "",
      "Tier.": "",
      "LTV(THB)": 0,
      "Total Revenue (THB)": 0,
      Transactions: 0,
      "Frequent Category": "",
      "Expensive Category": "",
      "Frequent Product": "",
      "Expensive Product": "",
    }
  );
};

const mapAllCustomerData = (datas) => {
  return !datas
    ? []
    : datas.map((t) => {
        //const dateTime = getDateTimeFormat(new Date(t.time), periodType);
        return {
          Date: t.time,
          Name: t.firstname ? `${t.firstname} ${t.lastname}` : "Walk-in",
          "LTV (THB)": t.ltv ?? 0,
          Transactions: t.payment.total_transaction,
          "Quantity (Units)": t.payment.total_qty,
          "Total Price": t.payment.total_payment,
          Discount: Math.abs(t.payment.total_discount ?? 0),
          "Total Revenue": t.payment.total_revenue,
          Cash: t.life_time?.total_payment_method?.Cash?.total_amount ?? 0,
          Transfer:
            t.life_time?.total_payment_method?.Transfer?.total_amount ?? 0,
          "Credit/Debit":
            t.life_time?.total_payment_method?.["Credit-Debit"]?.total_amount ??
            0,
        };
      });
};

const makeAllCustomerSummary = (datas) => {
  return !datas
    ? []
    : datas.reduce(
        (total, row) => {
          //const dateTime = getDateTimeFormat(new Date(t.time), periodType);
          return {
            Date: "Total",
            Name: "",
            "LTV (THB)": (row["LTV (THB)"] ?? 0) + total["LTV (THB)"],
            Transactions: (row["Transactions"] ?? 0) + total["Transactions"],
            "Quantity (Units)":
              (row["Quantity (Units)"] ?? 0) + total["Quantity (Units)"],
            "Total Price": (row["Total Price"] ?? 0) + total["Total Price"],
            Discount: (row["Discount"] ?? 0) + total["Discount"],
            "Total Revenue":
              (row["Total Revenue"] ?? 0) + total["Total Revenue"],
            Cash: (row["Cash"] ?? 0) + total["Cash"],
            Transfer: (row["Transfer"] ?? 0) + total["Transfer"],
            "Credit/Debit": (row["Credit/Debit"] ?? 0) + total["Credit/Debit"],
          };
        },
        {
          Date: "Total",
          Name: "",
          "LTV (THB)": 0,
          Transactions: 0,
          "Quantity (Units)": 0,
          "Total Price": 0,
          Discount: 0,
          "Total Revenue": 0,
          Cash: 0,
          Transfer: 0,
          "Credit/Debit": 0,
        }
      );
};
export {
  mapMemberReport,
  makeMemberSummary,
  mapMemberBigSpender,
  makeMemberBigSpenderSummary,
  mapAllCustomerData,
  makeAllCustomerSummary,
  // mapMemberPhoneReport,
  // makeMemberPhoneSummary,
};
